import springCenfApi from '../../services/springCenfApi'

export const getAppointments = params => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get('/appointments', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getAppointment = (id, params) => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get(`/appointments/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeAppointment = data => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.post('/appointments', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateAppointment = (id, data) => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.put(`/appointments/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteAppointment = id => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.delete(`/appointments/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getAvailableTimeSlots = data => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.post(`/appointments/availability`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const attachOrderDetailToAppointment = (appointmentId, data) => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.post(`/appointment_order_details/${appointmentId}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const detachOrderDetailFromAppointment = (appointmentId, orderDetailId) => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.delete(`/appointment_order_details/${appointmentId}/${orderDetailId}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getUpcomingUnavailableDays = () => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get('/unavailable_days?filter[upcoming]=1')
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)